import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { TAILLES, type Taille } from '../preferences/tailleStorage.js';
import styles from './BasculeVue.module.css';

const LETTRES: Record<Taille, string> = { petite: 'S', moyenne: 'M', grande: 'L' };

/** Sélecteur de taille des vignettes : petite, moyenne, grande (un seul pressé). */
export function BasculeTaille({
  taille,
  onChange,
}: {
  taille: Taille;
  onChange: (taille: Taille) => void;
}): JSX.Element {
  const { t } = useTranslation(['regie']);
  return (
    <div className={styles.bascule} role="group" aria-label={t('regie:commun.taille.libelle')}>
      {TAILLES.map((valeur) => (
        <button
          key={valeur}
          type="button"
          className={`${styles.bouton} ${styles.boutonTaille}`}
          aria-pressed={taille === valeur}
          aria-label={t(`regie:commun.taille.${valeur}`)}
          title={t(`regie:commun.taille.${valeur}`)}
          onClick={() => onChange(valeur)}
        >
          {LETTRES[valeur]}
        </button>
      ))}
    </div>
  );
}
